module.exports = __webpack_public_path__ + "static/media/9.eb3074a6.webp";